<template>
  <div v-cloak>
    <div class="vx-card mb-6">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <table class="basic-tbl" id="colored-table">
              <thead>
                <tr>
                  <th style="width: 10%">{{ $t("WarehouseName") }}</th>
                  <th style="width: 15%">{{ $t("Description") }}</th>
                  <th style="width: 10%">{{ $t("OperatorName") }}</th>
                  <th style="width: 13%">{{ $t("Applicant") }}</th>

                  <th style="width: 10%">{{ $t("AutomationCode") }}</th>
                  <th style="width: 10%">{{ $t("ShipmentNumber") }}</th>
                  <th style="width: 10%">{{ $t("CottageNumber") }}</th>
                  <th style="width: 10%">{{ $t("CreateOn") }}</th>
                  <th style="width: 12%">
                    {{ $t("DocumentRegistrationDate") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="width: 10%">
                    {{ headerInfo.storeName }}
                  </td>
                  <td style="width: 15%">{{ headerInfo.description }}</td>
                  <td style="width: 10%">
                    {{ headerInfo.inventoryOperatorName }}
                  </td>
                  <td style="width: 13%">
                    {{ headerInfo.inventoryRequesterName }}
                  </td>
                  <td style="width: 10%">
                    {{ headerInfo.automationCode }}
                  </td>
                  <td style="width: 10%; direction: ltr">
                    {{
                      headerInfo.shipmentNumber
                        ? headerInfo.shipmentNumber
                        : "---"
                    }}
                  </td>
                  <td style="width: 10%; direction: ltr">
                    {{
                      headerInfo.cottageNumber
                        ? headerInfo.cottageNumber
                        : "---"
                    }}
                  </td>
                  <td style="width: 12.5%; direction: ltr">
                    {{ headerInfo.persianDateTime }}
                  </td>
                  <td style="width: 12.5%; direction: ltr">
                    {{ headerInfo.persianRegisterClock }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ShelveName'), sort: 'ShelveName' },
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('Count'), sort: 'Count' },
                { title: $t('Serial'), sort: 'Serial' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 10%">
                  {{ row.shelveName }}
                </td>
                <td style="width: 45%">
                  {{ row.stockName }}
                </td>
                <td style="width: 15%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 15%">
                  {{ row.count }}
                </td>
                <td style="width: 20%">
                  <span v-if="row.stockType == 1">
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="custom-border-btn"
                      @click="
                        viewSerials(
                          row.inventoryTransactionId,
                          row.shelveId,
                          row.stockId
                        )
                      "
                      v-has-permission="'GetSerialsOfStock'"
                      >{{ $t("ViewSerials") }}</vs-button
                    >
                  </span>
                  <span v-else>-</span>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
    <serials-list
      :show="SerialsListPopup"
      @finish="onfinish"
      :popupService="popupService"
    ></serials-list>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import SerialsList from "./SerialsList.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "warehouseManagement_CheckinTransactions_Details",
  components: {
    DataGrid,
    SerialsList,
  },
  data() {
    var id = this.$route.params.id;
    return {
      gridDataSource: {
        type: "app",
        service: "Inventory/api/InventoryTransactionsQuery/" + id + "/0",
      },
      gridSearchData: {},
      SerialsListPopup: false,
      popupService: "",
    };
  },
  computed: {
    ...mapGetters({
      headerInfo: "inventoryTransaction/details",
    }),
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchSingle: "inventoryTransaction/fetchSingle",
    }),
    load() {
      var id = this.$route.params.id;
      this.fetchSingle(id);
    },
    viewSerials(inventoryTransactionId, shelveId, stockId) {
      this.popupService =
        "/Inventory/api/InventoryTransactionsQuery/serials/" +
        inventoryTransactionId +
        "/" +
        shelveId +
        "/" +
        stockId;
      this.SerialsListPopup = true;
    },
    onfinish() {
      this.SerialsListPopup = false;
      // this.$refs.grid.renderGrid();
    },
  },
};
</script>
